import { mapGetters, mapActions } from 'vuex'
import { listCarriers } from 'src/stubs/carriers'
import { convertToSlugArray } from 'src/filters'
import { uniq, isEmpty } from 'lodash'

export default {
  data () {
    let validatorCity = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Tỉnh thành không được để trống'))
      } else {
        callback()
      }
    }
    let validatorDistrict = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Quận huyện không được để trống'))
      } else {
        callback()
      }
    }
    return {
      localWard: {
        id: 0,
        name: '',
        short_name: '',
        city_id: 0,
        district_id: 0
      },
      regionTable: 'regions',
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên phường xã', trigger: 'change'},
          {min: 5, max: 255, message: 'Tên phường xã phải trong khoảng 5 đến 255 ký tự', trigger: 'change'}
        ],
        city_id: [
          {required: true, validator: validatorCity, trigger: 'change'}
        ],
        district_id_id: [
          {required: true, validator: validatorDistrict, trigger: 'change'}
        ]
      },
      listCarriers: listCarriers,
      defaultCarriers: {
        vtp: false,
        vnp: false,
        ghn: false,
        ghtk: false,
        njv: false,
        hbb: false,
        kerry: false,
        spl: false,
        supership: false,
        snappy: false,
        hola: false,
        nhattin: false
      },
      dataCarriers: {
        vtp: {},
        vnp: {},
        ghn: {},
        ghtk: {},
        njv: {},
        hbb: {},
        kerry: {},
        spl: {},
        supership: {},
        snappy: {},
        hola: {},
        nhattin: {}
      },
      checkedCarrier: false,
      submitting: false,
      mapNames: [],
      options: [],
      isUpdating: false,
    }
  },
  computed: {
    ...mapGetters('city', ['city', 'cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('carrier', ['carriers'])
  },
  methods: {
    ...mapActions('city', ['getCity', 'getAllCity']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('carrier', ['getAllCarriers']),
    pushCarrier (carrier) {
      this.dataCarriers[carrier.short_name] = {
        id: carrier.id,
        kind_to: 0,
        kind_from: 0
      }
    },
    newWard () {
      this.localWard = {
        id: 0,
        name: '',
        short_name: '',
        city_id: 0,
        district_id: 0
      }
    },
    getDistricts () {
      this.localWard.district_id = ''
      this.getDistrictByCityId({city_id: this.localWard.city_id, limit: -1, sort: 'name:1'})
    },
    handleChange(newValue) {
      if (this.isUpdating) return
      const latestValue = newValue[newValue.length - 1] // Lấy giá trị mới nhất
      if (!latestValue) return
      if (isEmpty(latestValue) || !/[a-zA-Z0-9]/.test(latestValue)) {
        this.isUpdating = true
        // Loại bỏ giá trị không hợp lệ và cập nhật sau khi DOM đã render
        this.mapNames = newValue.slice(0, -1) // Lấy tất cả phần tử trừ phần tử cuối
        this.$nextTick(() => {
          this.isUpdating = false
        })
        return
      }
      const isNew = !this.options.some((opt) => opt.value === latestValue)

      if (isNew) {
        this.isUpdating = true
        const slugValue = convertToSlugArray(latestValue) // Chuyển đổi giá trị mới thành slug
        // Thay thế giá trị mới bằng slug trong mảng
        this.mapNames.splice(newValue.length - 1, 1, slugValue)
        this.mapNames = uniq(this.mapNames)
        // Thêm cả giá trị gốc và slug vào options
        this.$nextTick(() => {
          this.isUpdating = false // Tắt flag sau khi cập nhật xong
        })
      }
    },
  },
  mounted () {
    this.newWard()
    if (!this.cities.length) {
      this.getAllCity({limit: -1, sort: 'name:1'})
    }
    if (!this.carriers.length) {
      this.getAllCarriers({limit: -1})
    }
  },
  watch: {
    localWard: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ward/mixins/index.js